import { Link } from "react-router-dom";
import styles from "./AIInsightsHighlight.module.css";

const CheckIcon = () => (
  <svg viewBox="0 0 24 24" aria-hidden="true">
    <polyline points="20 6 9 17 4 12" />
  </svg>
);

const AIIcon = () => (
  <svg viewBox="0 0 24 24" aria-hidden="true">
    <path d="M12 2v4M12 18v4M4.93 4.93l2.83 2.83M16.24 16.24l2.83 2.83M2 12h4M18 12h4M4.93 19.07l2.83-2.83M16.24 7.76l2.83-2.83" />
    <circle cx="12" cy="12" r="3" />
  </svg>
);

const bullets = [
  {
    title: "Strength detection",
    body: "Surfaces top 5% capabilities benchmarked against thousands of similar candidates.",
  },
  {
    title: "Risk flags",
    body: "Honest read on growth areas — so there are no surprises after the offer is signed.",
  },
  {
    title: "Role-fit reasoning",
    body: 'Every match comes with a "why" — explainable, not a black box.',
  },
];

export default function AIInsightsHighlight() {
  return (
    <section className={styles.section}>
      <div className={styles.container}>
        <div className={styles.grid}>
          {/* ── Left: text ── */}
          <div className={styles.textCol}>
            <span className={styles.tag}>Feature spotlight</span>
            <h2 className={styles.h2}>
              AI Insights that read between the lines.
            </h2>
            <p className={styles.lead}>
              Awasource turns assessment data, profile signals and behavioral
              patterns into a plain-English read on every candidate — so you can
              decide in minutes, not weeks.
            </p>

            <ul className={styles.bullets}>
              {bullets.map((b) => (
                <li key={b.title}>
                  <span className={styles.check}>
                    <CheckIcon />
                  </span>
                  <div>
                    <b>{b.title}</b>
                    <span>{b.body}</span>
                  </div>
                </li>
              ))}
            </ul>

            <Link
              to="/login"
              className={`${styles.btn} ${styles.btnPrimary} ${styles.btnLg}`}
            >
              See AI Insights live
            </Link>
          </div>

          {/* ── Right: AI insight mock ── */}
          <div className={styles.mock}>
            {/* Header */}
            <div className={styles.mockHead}>
              <div className={styles.aiAvatar}>
                <AIIcon />
              </div>
              <div>
                <div className={styles.mockTitle}>Awasource AI · Insight</div>
                <div className={styles.mockSub}>
                  Generated for: Senior Product Designer · 96% match
                </div>
              </div>
            </div>

            {/* Insight blocks */}
            <div className={`${styles.block} ${styles.blockAccent}`}>
              <b>Adaeze is a strong cross-functional designer</b> with verified
              strengths in user research and design systems. Benchmarks place
              her in the top 5% for systems thinking among 8,400+ similar
              candidates.
            </div>

            <div className={styles.block}>
              <b>Why this is a strong match:</b> Her assessment shows high
              consistency between stated experience and demonstrated skill — a
              signal we see in{" "}
              <b>89% of candidates who pass technical interviews</b> at similar
              roles.
              <div className={styles.tags}>
                <span className={`${styles.pill} ${styles.pillGreen}`}>
                  + Systems thinking
                </span>
                <span className={`${styles.pill} ${styles.pillGreen}`}>
                  + User research
                </span>
                <span className={`${styles.pill} ${styles.pillGreen}`}>
                  + Cross-functional
                </span>
              </div>
            </div>

            <div className={styles.block}>
              <b>Watch for in interviews:</b> Stakeholder communication scored
              slightly below role benchmark. Worth a behavioral question.
              <div className={styles.tags}>
                <span className={`${styles.pill} ${styles.pillAmber}`}>
                  ~ Stakeholder comms
                </span>
              </div>
            </div>

            <div className={styles.meta}>
              <span>Based on 14 verified signals</span>
              <span className={styles.metaLink}>View full report →</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
